/* global axios */

import ApiClient from '../ApiClient';

class MultiLeadsAPI extends ApiClient {
  constructor() {
    super('integrations/multi_leads', { accountScoped: true });
  }

  checkIntegration() {
    return axios.get(`${this.url}/check_integration`);
  }

  fetchTenantData(tenantId, token) {
    return axios.get(`${this.url}/fetch_tenant_data`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { tenant_id: tenantId },
    });
  }

  fetchLeadData(personId, token) {
    return axios.get(`${this.url}/fetch_lead_data`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { person_id: personId },
    });
  }

  fetchPersonData(multiatendedor_contact_id, token) {
    return axios.get(`${this.url}/fetch_person_data`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { multiatendedor_contact_id: multiatendedor_contact_id },
    });
  }

  fetchUserData(tenantId) {
    const url = `${this.url}/fetch_user_data`;
    return axios.get(url, {
      params: {
        tenant_id: tenantId,
      },
    });
  }

  fetchGroupData(tenantId) {
    const url = `${this.url}/fetch_group_data`;
    return axios.get(url, {
      params: {
        tenant_id: tenantId,
      },
    });
  }

  fetchPipelines(tenantId) {
    const url = `${this.url}/fetch_pipeline_data`;
    return axios.get(url, {
      params: {
        tenant_id: tenantId,
      },
    });
  }

  getLeadTypes(tenantId) {
    const url = `${this.url}/fetch_lead_type_data`;
    return axios.get(url, {
      params: {
        tenant_id: tenantId,
      },
    });
  }

  fetchSettings() {
    return axios.get(this.url);
  }

  createLead(leadData) {
    const url = `${this.url}/create_lead`;
    return axios.post(url, leadData);
  }
}

export default new MultiLeadsAPI();
